import { render } from "./BreedingManagerAdmin.vue?vue&type=template&id=66565716&scoped=true&ts=true"
import script from "./BreedingManagerAdmin.vue?vue&type=script&lang=ts"
export * from "./BreedingManagerAdmin.vue?vue&type=script&lang=ts"

import "./BreedingManagerAdmin.vue?vue&type=style&index=0&id=66565716&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66565716"]])

export default __exports__